import styled from "styled-components";

export const StyledMemoExceptionBlock = styled.div`
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 10px;
`;